import React, { useCallback } from "react"
import { StyleSheet, Text, View } from "react-native"

import Base from "../../base"
import { ExpandableButton } from "../common"
import Collapsible from "../common/Collapsible"
import Gap from "../common/Gap"

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
]

export default function OpeningHours(props) {
  function toTwo(number = 0) {
    const string = number.toString()
    return string.length === 2 ? string : "0" + string
  }

  function hoursString(day) {
    const times = props.service.openingTimes[day.toLowerCase()]
    if (!times.open) {
      return "Closed"
    }
    let fromTime = toTwo(times.from.hour) + ":" + toTwo(times.from.minute)
    let toTime = toTwo(times.to.hour) + ":" + toTwo(times.to.minute)
    return fromTime + " - " + toTime
  }

  const renderHeader = useCallback(
    headerProps => <ExpandableButton title="Trading Times" {...headerProps} />,
    [],
  )

  if (!props.service) {
    return null
  }

  return (
    <Collapsible RenderHeader={renderHeader}>
      <Gap size={10} />
      {props.service.openingTimes ? (
        days.map((day, index) => {
          return (
            <View style={styles.row} key={index}>
              <Text style={[Base.styles.body, styles.day]}>{day}</Text>
              <Text style={Base.styles.body}>{hoursString(day)}</Text>
            </View>
          )
        })
      ) : (
        <Text style={[Base.styles.body]}>Trading hours not set up</Text>
      )}
    </Collapsible>
  )
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    justifyContent: "flex-start",
    marginVertical: 4,
  },

  day: {
    width: 130,
  },
})
